import { Faqs } from 'context/page-form-context';

import styles from './content-map.module.scss';

interface FaqsContentMapProps {
  faqs: Faqs;
}

const FaqsContentMap = ({ faqs }: FaqsContentMapProps) => {
  return (
    <>
      {faqs.map((faq) => (
        <div key={faq.question}>
          <div className={styles.faqQuestion}>{faq.question}</div>
          <div className={styles.faqAnswer}>{faq.answer}</div>
          <br />
          <br />
        </div>
      ))}
    </>
  );
};

export { FaqsContentMap };
